import type { OrderOfferVariant } from '@fourthwall/services/dist/models/order'

export interface Variant {
  prefix: string
  value: string
}

export const getVariants = ({ attributesList }: OrderOfferVariant): Variant[] => {
  const variantsArray: Variant[] = []

  const size = attributesList.find(({ type }) => type === 'SIZE')
  const color = attributesList.find(({ type }) => type === 'COLOR')
  if (size) {
    variantsArray.push({ prefix: 'Size', value: size.name })
  }

  if (color) {
    variantsArray.push({ prefix: 'Color', value: color.name })
  }

  return variantsArray
}

export const getVariantsString = (variant: OrderOfferVariant) => {
  return getVariants(variant)
    .map(({ prefix, value }) => `${prefix}: ${value}`)
    .join(', ')
}

export const getAttributesText = (
  attributes: Record<string, string>,
  variantTypes: { type: string; title: string }[],
) => {
  return Object.entries(attributes)
    .sort((a, b) => {
      const types = [...variantTypes].reverse()
      const aIndex = types.findIndex(({ type }) => type === a[0])
      const bIndex = types.findIndex(({ type }) => type === b[0])

      return -(aIndex - bIndex)
    }) // reflect variant types order
    .map(([key, value]) => [variantTypes.find(({ type }) => type === key)?.title || key, value]) // ["Color", "Red"], ["Size", "Small"]
    .map((entry) => entry.join(': ')) // ["Color: Red"], ["Size: Small"]
    .join(', ') // Color: Red, Size: Small
}
